// Centralised site configuration for Rincon Web
export const SITE = {
  brand: "Rincón Web",
  tagline: "Diseño y desarrollo web profesional",
  whatsappNumber: "5218116808797", // E.164 without "+" for wa.me
  whatsappDisplay: "+52 811 680 8797",
  defaultWhatsAppMessage:
    "Hola Rincón Web, quiero información sobre sus servicios de diseño y desarrollo web.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_creamos-webs/artifacts/wsa2p2vg_LogoRinconWebTransp.png",
};

export const waLink = (text) => {
  const message = encodeURIComponent(text || SITE.defaultWhatsAppMessage);
  return `https://wa.me/${SITE.whatsappNumber}?text=${message}`;
};
